module.exports = require('./lib/axios');


// WEBPACK FOOTER //
// ./~/axios/index.js